export default __webpack_public_path__ + "c629fd6821c3fc259163dd84003d9f7c.svg";